import { render, staticRenderFns } from "./FollowUpClinic.vue?vue&type=template&id=edff2b34&scoped=true"
import script from "./FollowUpClinic.vue?vue&type=script&lang=js"
export * from "./FollowUpClinic.vue?vue&type=script&lang=js"
import style0 from "./FollowUpClinic.vue?vue&type=style&index=0&id=edff2b34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edff2b34",
  null
  
)

export default component.exports